<template>
   
    <v-row dense no-gutters>
      <v-col
        v-for="item in datosNew"
        :key="item.Codigo"
        cols="12"
        :sm="isdrawer ? 12 : 6"
      >
      <ItemCar :item="item" />
       
      </v-col>
    </v-row>

</template>

<script>
import { mapState } from "vuex";

import ItemCar from "./ItemCar.vue";
export default {
  props: {
    isdrawer: {
      default: false,
      type: Boolean,
    },
  },
  components: {

    ItemCar
  },
  data() {
    return {
    
      imgP: false,
      dialogEliminar: {
        dialog: false,
        articulo: {},
        info: "",
      },
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  methods: {

  
    
  
   
  
  },
  computed: {
    ...mapState([
      "Pedido",
      "Cliente",
      "tipoMoneda",
      "simboloMoneda",
      "loading",
      "domoapi2_img",
    ]),
    datosNew() {
      let xDatos = [];
      if (Object.entries(this.Pedido).length !== 0) {
        let { items: items } = this.Pedido;
        if (Object.entries(items).length !== 0) xDatos = items;
      }
      return xDatos;
    },
  },
};
</script>

<style scoped>
.ribbonpromo {
  z-index: 1;
  position: absolute;
  top: 23px;
  left: 3px;
  width: 100px;
  display: block;
  padding: 1px;
  font-size: 10px;
  border-radius: 5px;
  background-color: #d3bc8d;
  color: #7c2629;
  text-align: center;
  border-left: 2px solid #b05954 !important;
  border-top: 2px solid #b05954 !important;
}
.my-div {
  max-width: 180px;
  /* Ajusta el valor según tus necesidades */
}
.img_art {
  width: auto;

  height: 100%;
}
</style>
